import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import React from "react";

const DotLottieReact = React.lazy(() =>
  import("@lottiefiles/dotlottie-react").then(module => ({
    default: module.DotLottieReact,
  }))
);

const ConfirmDataModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [visibleItems, setVisibleItems] = useState<number[]>([]);
  const [checklistComplete, setChecklistComplete] = useState(false);

  const items = [
    "Uploading Document",
    "Extracting Information",
    "Data Validation & Verification",
  ];
  useEffect(() => {
    setShowModal(true);
    setChecklistComplete(false);
    setVisibleItems([]);
    const delays = [800, 1600, 2300];

    const showChecklistItem = (index: number) => {
      if (index < delays.length) {
        setTimeout(() => {
          setVisibleItems((prev) => [...prev, index]);
          showChecklistItem(index + 1);
        }, delays[index]);
      } else {
        setTimeout(() => {
          setChecklistComplete(true);
        }, 1500);

        setTimeout(() => {
          setShowModal(false);
          setChecklistComplete(false);
          setVisibleItems([]);
        }, 3000);
      }
    };

    showChecklistItem(0);
  }, []);

  return (
    <div>
      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-sm"
      >
        <Modal.Body className="rounded scanning-main">
          <div
            className={`scanning-up d-flex flex-column align-items-center justify-content-center ${
              checklistComplete ? "hidden" : ""
            }`}
          >
            <DotLottieReact
              src="https://lottie.host/58aa72f0-22de-45e6-beab-4a3efd3dfa7f/eBVENNCsyj.lottie"
              loop
              autoplay
              style={{ width: "150px", height: "150px" }}
            />
            <ul>
              {items.map((text, index) => (
                <li
                  key={index}
                  className={`d-flex align-items-center gap-2 checklist-fade ${
                    visibleItems.includes(index) ? "show" : ""
                  }`}
                >
                  <div>
                    <img
                      src="https://goodhand.b-cdn.net/Assets/cart/tick-ico-2.svg"
                      alt=""
                      style={{ width: "12px", height: "12px" }}
                    />
                  </div>
                  <p className="mb-0 font-14 ff-semibold">{text}</p>
                </li>
              ))}
            </ul>
          </div>

          {checklistComplete && (
            <div className="done-check visible">
              <DotLottieReact
                src="https://lottie.host/7a962458-bb58-4acd-ae34-c8521f1f928e/6eeOKQV9tx.lottie"
                loop
                autoplay
                style={{ width: "150px", height: "150px" }}
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConfirmDataModal;
